module.exports = __webpack_public_path__ + "static/deal_2-98000d4d9e695525ed0d2c0e982b5a40.png";